import cn from "classnames"
import React from "react"

import style from "modules/PsyProfile/components/BookingMobile/style.module.scss"
import { useSearchParams } from "utils/customHooks"
import { isBrowser } from "utils/infrastructure/ssg-utils"
import { getRawURLFormData } from "utils"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { getBookingAvailableWithSlots, getLocationPath } from "utils/helpers"
import { NewBookingPageLink } from "app/AppRouter/links"
import { APP_STATUSES } from "utils/AppStatusContext"
import { Psychologist } from "utils/interfaces"

interface Props {
    psy: Psychologist
    selectGroup: ServicesGroup | undefined
    visibleBooking: boolean
    onClickButton: () => void
}

export function BookingMobile({ psy, selectGroup, visibleBooking, onClickButton }: Props) {
    const bookingAvailable = getBookingAvailableWithSlots(psy)
    const pathName = getLocationPath()
    const searchParams = useSearchParams()
    const position = searchParams.get("position") ?? "1"
    const bookingQuery = isBrowser() ? (getRawURLFormData(window.location.href) ?? {}) : {}

    const getButtonText = () => {
        if (visibleBooking) return bookingAvailable ? "Посмотреть время" : "Запросить время"
        return "Выбрать услугу"
    }

    const buttonText = getButtonText()

    const handleClickButton = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (!visibleBooking) {
            event.preventDefault()
            onClickButton()
        }
    }

    return (
        <div className={style.container}>
            <NewBookingPageLink
                query={bookingQuery}
                position={position}
                hashId={psy.hash_id}
                from={APP_STATUSES.profile}
                fromLink={pathName}
                className={cn(style.button, {
                    "button-primary": bookingAvailable,
                    "button-secondary": !bookingAvailable,
                    [style.isSecondary]: !bookingAvailable,
                })}
                data-testid={
                    bookingAvailable
                        ? "psy-profile-mobile-pick-time"
                        : "psy-profile-mobile-request-time"
                }
                state={{
                    serviceGroupId: selectGroup
                        ? selectGroup.services[0].service_type_id
                        : undefined,
                }}
                onClick={handleClickButton}
            >
                {buttonText}
            </NewBookingPageLink>
        </div>
    )
}
